import React from "react";
import SEO from "../components/SEO";
import contactData from "../data/contact.json";
import { logActivity } from "../utils/activity";

export default function Contact() {
  return (
    <div className="bg-slate-50">
      <SEO
        title={contactData.seo?.title}
        description={contactData.seo?.description}
        ogType="website"
        ogImage={contactData.seo?.ogImage}
      />
      <section className="section-padding mx-auto w-full max-w-6xl">
        {/* <!-- Replace with dynamic content from JSON --> */}
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          Contact
        </p>
        <h1 className="page-title mt-3">
          {contactData.headline}
        </h1>
        <p className="mt-4 text-lg text-slate-600">{contactData.subtitle}</p>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto grid w-full max-w-6xl gap-10 md:grid-cols-[1.1fr_0.9fr]">
          <form className="card space-y-4 p-8">
            <h2 className="text-xl font-semibold text-slate-900">
              Send a message
            </h2>
            <div className="grid gap-3 md:grid-cols-2">
              <input
                className="rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 transition"
                placeholder="Name"
                type="text"
              />
              <input
                className="rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 transition"
                placeholder="Email"
                type="email"
              />
            </div>
            <input
              className="w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 transition"
              placeholder="Phone"
              type="tel"
            />
            <textarea
              className="min-h-[140px] w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 transition"
              placeholder="Message"
            />
            <button
              className="btn btn-primary"
              onClick={() =>
                logActivity("cta_click", { label: "Contact form submit" })
              }
            >
              Send to Manage Your Vastu
            </button>
          </form>

          <div className="space-y-6">
            <div className="card p-6 text-sm text-slate-600">
              <p className="font-semibold text-slate-900">
                Manage Your Vastu Support
              </p>
              <p className="mt-2">Email: {contactData.email}</p>
              <p>Phone: {contactData.phone}</p>
              <p>Location: {contactData.address}</p>
            </div>
            <div className="card flex h-52 items-center justify-center border-dashed text-sm text-slate-400">
              Google Map iframe placeholder
            </div>
            {/* <!-- Replace with dynamic content from JSON --> */}
          </div>
        </div>
      </section>

      <button
        className="btn btn-primary fixed bottom-6 right-6 bg-green-500 shadow-lg hover:bg-green-400"
        onClick={() => logActivity("cta_click", { label: "WhatsApp" })}
      >
        WhatsApp Manage Your Vastu
      </button>
    </div>
  );
}
